
import { useEffect, useRef, useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FaPlus, FaTrash } from 'react-icons/fa';

import { InputTextarea } from 'primereact/inputtextarea';
import { Api } from '../../services/api';
import { VpSalesAndMarketingTemplated } from '../../services/Template/vp-sales-and-marketing';
import { ProgressBar } from 'primereact/progressbar';
import { useNavigate, useParams } from 'react-router-dom';
import { InputNumber } from 'primereact/inputnumber';
import { IoArrowBackSharp } from 'react-icons/io5';


const VpSalesAndMarketing = () => {
    var isAdmin =    localStorage.getItem('isAdmin');

    const navigate = useNavigate();

    const { viewUserId } = useParams();
    const { viewRoleId } = useParams();
    const [billableTime, setBillableTime] = useState([]);
    const [annualDeliverables, setAnnualDeliverables] = useState(VpSalesAndMarketingTemplated.getFormName().annual_deliveables);
    const [primaryTask, setPrimaryTask] = useState(VpSalesAndMarketingTemplated.getFormName().primary_task);
    const [secondaryTask, setSecondaryTask] = useState(VpSalesAndMarketingTemplated.getFormName().secondary_task);
    const [anyAddtionalTopic, setAnyAddtionalTopic] = useState(VpSalesAndMarketingTemplated.getFormName().any_addtional_topic);
    const [goalsForTheWeek, setGoalsForTheWeek] = useState(VpSalesAndMarketingTemplated.getFormName().goals_for_the_week);
    const [webStats, setWebStats] = useState(VpSalesAndMarketingTemplated.getFormName().web_stats);
    const [marketingCampaigns, setMarketingCampaigns] = useState(VpSalesAndMarketingTemplated.getFormName().marketing_campaigns);
    const [googleAdwords, setGoogleAdwords] = useState(VpSalesAndMarketingTemplated.getFormName().google_adwords);
    const [bingsAdwords, setBingsAdwords] = useState(VpSalesAndMarketingTemplated.getFormName().bings_adwords);
    const [houzz, setHouzz] = useState(VpSalesAndMarketingTemplated.getFormName().houzz);
    const [facebookInstgramAds, setFacebookInstgramAds] = useState(VpSalesAndMarketingTemplated.getFormName().facebook_instgram_ads);
    const [linkedins, setLinkedins] = useState(VpSalesAndMarketingTemplated.getFormName().linkedins);
    const [socialMediaStats, setSocialMediaStats] = useState(VpSalesAndMarketingTemplated.getFormName().social_media_stats);


    const [isLoading, setIsLoading] = useState(true);
    const [annualQuarters, setAnnualQuarters] = useState([]);
    // --------------------------------------------------------------------
    const [dateInput1, setDateInput1] = useState("");
    const [dateInput2, setDateInput2] = useState("");
    const [dateInput3, setDateInput3] = useState("");
    const [dateInput4, setDateInput4] = useState("");

    const [checkAdmin, setCheckAdmin] = useState('');

    //--------------------------------------
    const [perBonusMeasurablesReview, setPerBonusMeasurablesReview] = useState(VpSalesAndMarketingTemplated.getFormName().performance);
    const [dataForPer, setDataForPer] = useState(45);
    const [discussionItem, setDiscussionItem] = useState(VpSalesAndMarketingTemplated.getFormName().discussionItem);
    const [toDiscuss, setToDiscuss] = useState(VpSalesAndMarketingTemplated.getFormName().toDiscuss);
    const [totalPointMeetingJob, setTotalPointMeetingJob] = useState("");
    const [pointsMeetingJob, setPointsMeetingJob] = useState("");

    const handleAddInputForMonthlyClientRating = () => {
        var s = {
            performanceBonusMeasReview: "",
            clientPlayBook: "",
            vpPoints_1: "",
            clientEmailWeek: "",
            vpPoints_2: "",
            pmComments: "",
            vpCOComments: ""
        };
        setPerBonusMeasurablesReview([...perBonusMeasurablesReview, s]);
        formik.values.performance.push(s);
    };
    const handleDeleteInputForMonthlyClientRating = (index) => {
        formik.values.performance.splice(index, 1);
        setPerBonusMeasurablesReview([...perBonusMeasurablesReview, VpSalesAndMarketingTemplated.getFormName().performance[0]]);
        var newArray = [...perBonusMeasurablesReview];
        newArray.splice(index, 1);
        setPerBonusMeasurablesReview(newArray);
    };

    const handleAddInputFordiscussionItem = () => {
        console.log('formik.values.discussionItem', formik.values.discussionItem)

        setDiscussionItem([...discussionItem, VpSalesAndMarketingTemplated.getFormName().discussionItem[0]]);
        formik.values.discussionItem.push({ discussion_items: '' });
    };

    const handleDeleteInputFordiscussionItem = (index) => {
        formik.values.discussionItem.splice(index, 1);
        setDiscussionItem([...discussionItem, VpSalesAndMarketingTemplated.getFormName().discussionItem[0]]);
        var newArray = [...discussionItem];
        newArray.splice(index, 1);
        setDiscussionItem(newArray);
    };

    const handleAddInputFortoDiscuss = () => {
        setToDiscuss([...toDiscuss, VpSalesAndMarketingTemplated.getFormName().toDiscuss[0]]);
        formik.values.toDiscuss.push(VpSalesAndMarketingTemplated.getFormName().toDiscuss[0]);
    };

    const handleDeleteInputFortoDiscuss = (index) => {
        formik.values.toDiscuss.splice(index, 1);
        setToDiscuss([...toDiscuss, VpSalesAndMarketingTemplated.getFormName().toDiscuss[0]]);
        var newArray = [...toDiscuss];
        newArray.splice(index, 1);
        setToDiscuss(newArray);
    };


    const [userName, setUserName] = useState("");
    const toast = useRef(null);


    const formik = useFormik({
        initialValues: VpSalesAndMarketingTemplated.getFormName(),
        validate: (data) => {

        },

        onSubmit: (data) => {

            data.total_points_meeting_job = totalPointMeetingJob;
            data.points_meeting_job = pointsMeetingJob;

            // data.user_id = localStorage.getItem('user_id');
            // data.role_id = localStorage.getItem('role_id');
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            var url = Api.API_BASE_URL + 'vp-sales-marketing/save';


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });


    // TODO ------------------------ 
    const handleAddInputForAnnualDeliverables = () => {
        setAnnualDeliverables([...annualDeliverables, { title: '', description: '', lida_homes_core_value: '', }]);
        formik.values.annual_deliveables.push({ title: '', description: '' });
    }

    const handleDeleteInputForAnnualDeliverables = (index) => {
        formik.values.annual_deliveables.splice(index, 1);
        setAnnualDeliverables([...annualDeliverables, { title: '', description: '' }]);
        var newArray = [...annualDeliverables];
        newArray.splice(index, 1);
        setAnnualDeliverables(newArray);
    };



    const handleAddInputForGoalsForTheWeek = () => {
        setGoalsForTheWeek([...goalsForTheWeek, { title: '', status_1: '', status_2: '', reason_1: '', reason_2: '', }]);
        formik.values.goals_for_the_week.push({ title: '', status_1: '', status_2: '', reason_1: '', reason_2: '', });
    }

    const handleDeleteInputForGoalsForTheWeek = (index) => {
        formik.values.goals_for_the_week.splice(index, 1);
        setGoalsForTheWeek([...goalsForTheWeek, { title: '', status_1: '', status_2: '', reason_1: '', reason_2: '', }]);
        var newArray = [...goalsForTheWeek];
        newArray.splice(index, 1);
        setGoalsForTheWeek(newArray);
    };




    //! -----------------------
    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
    };

    const cellStyle = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
        border: '1px solid white',
        padding: '1px',
    };


    const cellStylea = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "start",
        fontSize: "14px",
        padding: "5px",
        border: '1px solid white',

    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',
        fontSize: "18px",
    };

    const cellStyleH = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
        border: '1px solid white',
        height: '50px'
    };


    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px',
        fontSize: "14px",

    };

    const cellStyleD = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: '#9999',
        fontSize: "14px",

    };

    const yesCellStyle = {
        ...cellStyle,
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    //! ----------------------------------------------------------

    useEffect(() => {


      
        setIsLoading(false);
        var name = localStorage.getItem('name');
        setUserName(name);

        if (viewRoleId == undefined || viewUserId == undefined) {
            var user_id = localStorage.getItem('user_id');
            var role_id = localStorage.getItem('role_id');
            performancePoints(user_id, role_id);
        } else {
            performancePoints(viewUserId, viewRoleId);
        }


        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);

    const performancePoints = (user_id, role_id) => {

        var _body = {
            userId: user_id,
            role_id: role_id,

        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        formik.setFieldValue('user_id',user_id);
        formik.setFieldValue('role_id', role_id);
        fetch(Api.API_BASE_URL + 'vp-sales-marketing/get', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                // setProjectionAndAcutal(response.projectionAndAcutal);

                setTotalPointMeetingJob(response.total_points_meeting_job);
                setPointsMeetingJob(response.points_meeting_job);


                if (response.billableTime) {
                    setBillableTime(response.billableTime);
                }

                if (response.annualquarters) {

                    setAnnualQuarters(response.annualquarters);

                    formik.setFieldValue('q1', response.annualquarters[0].ltTeam);
                    formik.setFieldValue('q2', response.annualquarters[1].ltTeam);
                    formik.setFieldValue('q3', response.annualquarters[2].ltTeam);
                    formik.setFieldValue('q4', response.annualquarters[3].ltTeam);

                    formik.setFieldValue('vpCommentsq1', response.annualquarters[0].vpComments);
                    formik.setFieldValue('vpCommentsq2', response.annualquarters[1].vpComments);
                    formik.setFieldValue('vpCommentsq3', response.annualquarters[2].vpComments);
                    formik.setFieldValue('vpCommentsq4', response.annualquarters[3].vpComments);

                    formik.setFieldValue('coreValuesq1', response.annualquarters[0].coreValues);
                    formik.setFieldValue('coreValuesq2', response.annualquarters[1].coreValues);
                    formik.setFieldValue('coreValuesq3', response.annualquarters[2].coreValues);
                    formik.setFieldValue('coreValuesq4', response.annualquarters[3].coreValues);


                }

                if (response.performanceHuddle) {


                    formik.setFieldValue('year_goal', response.performanceHuddle.year_goal);
                    formik.setFieldValue('check_in_how_are_you_doing', response.performanceHuddle.check_in_how_are_you_doing);
                    formik.setFieldValue('what_can_i_do_to_support_you', response.performanceHuddle.what_can_i_do_to_support_you);
                    formik.setFieldValue('vp_comment_1', response.performanceHuddle.vp_comment_1);
                    formik.setFieldValue('vp_comment_2', response.performanceHuddle.vp_comment_2);
                    formik.setFieldValue('vp_comment_3', response.performanceHuddle.vp_comment_3);
                    formik.setFieldValue('vp_comment_4', response.performanceHuddle.vp_comment_4);

                    if (response.performanceHuddle.from_date != '0000-00-00') {
                        formik.setFieldValue('from_date', response.performanceHuddle.from_date);
                        // handleDateInputChange("dateInput1", response.performanceHuddle.from_date)
                        let timestamp = new Date(response.performanceHuddle.from_date);


                        if (!isNaN(timestamp.getTime())) {
                            handleDateInputChange("dateInput1", timestamp.toISOString().split('T')[0])

                        }
                    }

                }

                if (response.annualDeliveables.length > 0) {
                    setAnnualDeliverables(response.annualDeliveables);
                    formik.setFieldValue(`annual_deliveables`, response.annualDeliveables);
                }
                if (response.goalsForTheWeek.length > 0) {
                    setGoalsForTheWeek(response.goalsForTheWeek);
                    formik.setFieldValue(`goals_for_the_week`, response.goalsForTheWeek);
                }
                if (response.toDiscuss.length != 0) {
                    setToDiscuss(response.toDiscuss);
                    formik.setFieldValue(`toDiscuss`, response.toDiscuss);
                }
                if (response.discussionItems.length > 0) {
                    setDiscussionItem(response.discussionItems);
                    formik.setFieldValue(`discussionItem`, response.discussionItems);
                }
                if (response.performance.length > 0) {

                    setPerBonusMeasurablesReview(response.performance);
                    formik.setFieldValue(`performance`, response.performance);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });

    }





    const handleDateInputChange = (inputId, selectedDate) => {
        // Update the state of the selected input
        switch (inputId) {
            case "dateInput1":
                setDateInput1(selectedDate);
                setDateInput2(addDays(selectedDate, 6));
                setDateInput3(addDays(selectedDate, 7)); // Adjusted to 7 days
                setDateInput4(addDays(selectedDate, 13)); // Adjusted to 13 days
                break;
            default:
                break;
        }
    };

    const addDays = (dateString, days) => {
        const date = new Date(dateString);
        date.setDate(date.getDate() + days);
        return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black" }}>
                {formatCurrency(rowData)}
                {/* $ {numberValue.toFixed(2) } */}
            </span>
        );
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    // --------------------------------------------------------------------

    const renderTextAreaFull = (fieldName, formData = '',background= 'white') => (
        <InputTextarea
            placeholder={''}
            name={fieldName}
            autoResize
            id={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}

            onChange={(e) => {
                console.log(e.target.value)
                // setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            className='px-2'
            style={{ 
                width: '100%', 
                boxSizing: 'border-box', 
                border: 'none', 
                outline: 'none', 
                color: '#495057', 
                display: 'flex', 
                lignItems: 'center', 
                paddingTop: '8px', 
                background: background
            }}
        ></InputTextarea>
    );

    const priceBodyTemplateeYearly = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black", }}>
                {formatCurrency(rowData)}
            </span>
        );
    };

    const renderInputAreaForAmount = (fieldName, formData = '') => {
        var roleId = localStorage.getItem('role_id')

        return (
            <InputNumber
                inputId="currency-us"
                className="text-center"
                inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
                placeholder="$0.00"
                value={formData != '' ? formData : formik.values[fieldName]}
                onChange={(e) => {
                    formik.setFieldValue(fieldName, e.value)
                }
                }
                // readOnly={roleId == 2 || roleId == 12 || roleId == 13 || roleId == 1 ? false : true}
                readOnly={isAdmin === 'Y' ? false : true}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                style={{
                    width: "100%",
                    height: "40px",
                    boxSizing: "border-box",
                    border: "none",
                    fontSize: "18px",
                    textAlign: "center !important",
                    marginTop: "0px",
                    outline: 'none',
                }}
            />
        )
    };


    const renderInputArea = (fieldName, formdata = '', type = 'text', color = 'white', placeholder = '') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formdata != '' ? formdata : formik.values[fieldName]}
            onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{ width: '100%', height: '46px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', textAlign: 'center', marginTop: '0px', backgroundColor: color }}
            onFocus={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            onBlur={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            autoComplete="off"
        />
    );

    const renderSelect1 = (fieldName, formData = '') => {
        // console.log('formData', formData);
        var val = (formData != '') ? formData : formik.values[fieldName];
        console.log('val', val);

        return <select
            name={fieldName}
            id={fieldName}
            value={(formData != '') ? formData : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
            <option value="N">No</option>
            <option value="Y">Yes</option>
        </select>
    };






    const totalClientEmailWeek = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });

        return (
            <span>
                {sum}
            </span>
        )
    }
    const cilentPlayBookTotalPerColor = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });

        var per = ((sum / dataForPer) * 100)
        var color = "#22A33D"
        if (per < 90) {
            color = "#FFBF00"
        }
        if (per < 80) {
            color = "red"
        }

        if (per < 70) {
            color = "red"
        }


        return (

            <ProgressBar value={per.toFixed(0)} color={color} ></ProgressBar>

        )
    }


    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit} >
                {/* <div className="flex d-flex justify-content-end top-button submitbutton ">
                    <Button title='Save the SALES & MARKETING - PERFORMANCE HUDDLE' className="m-2  p-2  d-flex align-items-center customSave-button" type="submit">
                        <strong className="mr-2 ">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>
                </div> */}

                {viewRoleId == undefined || viewUserId == undefined ?

                    (<div className="flex d-flex justify-content-end top-button submitbutton ">
                        <Button title='Save the SALES & MARKETING - PERFORMANCE HUDDLE' className="m-2  p-2  d-flex align-items-center customSave-button" type="submit">
                            <strong className="mr-2 ">Save</strong>
                            <i className="pi pi-save"></i>
                        </Button>

                    </div>)

                    : 'Y' == isAdmin  ?

                        (<div className="flex d-flex justify-content-between top-button submitbutton ">

                            <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                                <IoArrowBackSharp className='text-sm' />
                                <span>Back</span>
                            </button>

                            <Button title='Save the SALES & MARKETING - PERFORMANCE HUDDLE' className="m-2  p-2  d-flex align-items-center customSave-button" type="submit">
                                <strong className="mr-2 ">Save</strong>
                                <i className="pi pi-save"></i>
                            </Button>

                        </div>)
                        : (<div></div>)}


                <div className="cardd accordian-header" style={{ border: 'none', minHeight: '82vh', margin: 0, padding: 10 }} >

                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5]}>

                            <AccordionTab header="SALES & MARKETING - PERFORMANCE HUDDLE" className='mt-2 '>


                                <div className="table-container form-bg" style={{ overflowX: "auto", }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>

                                                <th style={{ ...headerStyle, }} colSpan={2} >
                                                    SALES & MARKETING - PERFORMANCE HUDDLE
                                                </th>
                                            </tr>

                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td style={{ ...cellStylea, height: "24px", }} colSpan={2}>
                                                    Client Email Playbook Update sent out on Friday after the 15th & 30th of every month.  Standard Email Client Update sent out every other Friday
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ ...cellStylea, minWidth: "125px", height: "24px", paddingTop: '10px', paddingBottom: '10px', }}>
                                                    Name: {<strong style={{ marginLeft: '65px', marginRight: '-45px' }}>{userName}</strong>}
                                                </td>

                                                <td style={{ ...cellStyle, minWidth: "250px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px' }}>

                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            From
                                                        </td>

                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            To
                                                        </td>
                                                        {/* <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            From
                                                        </td>
                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            To
                                                        </td> */}
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, }}>
                                                    Date:
                                                </td>

                                                <td style={{ minWidth: "250px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px', padding: 0 }}>

                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput1"
                                                                value={dateInput1}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("from_date", e.target.value)
                                                                    handleDateInputChange("dateInput1", e.target.value)
                                                                }}
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '17px', textAlign: 'center', marginTop: '0px', backgroundColor: '#9999' }}
                                                            />
                                                        </div>
                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput2"
                                                                disabled
                                                                value={dateInput2}
                                                                onChange={(e) => handleDateInputChange("dateInput2", e.target.value)}
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '17px', textAlign: 'center', marginTop: '0px', }}
                                                            />
                                                        </div>
                                                        {/* <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput3"
                                                                disabled
                                                                value={dateInput3}
                                                                onChange={(e) => handleDateInputChange("dateInput3", e.target.value)}
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '17px', textAlign: 'center', marginTop: '0px', }}
                                                            />
                                                        </div>
                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput4"
                                                                value={dateInput4}
                                                                disabled
                                                                onChange={(e) => handleDateInputChange("dateInput4", e.target.value)}
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '17px', textAlign: 'center', marginTop: '0px', }}
                                                            />
                                                        </div> */}
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>


                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: '300px', }}>
                                                    Quarter
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    LT Team {new Date().getFullYear()} ROCK
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    Projections & Actuals
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>                                                    
                                                    Yearly/Quarterly Variance
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    VP Construction OPS Comments Only
                                                </th>
                                                {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                   Core Values
                                                </th> */}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                annualQuarters.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.Quarter}</td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.ltTeam)}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderInputAreaForAmount(`q1`, formik.values.q1) : index == 1 ? renderInputAreaForAmount(`q2`, formik.values.q2) : index == 2 ? renderInputAreaForAmount(`q3`, formik.values.q3) : index == 3 ? renderInputAreaForAmount(`q4`, formik.values.q4) : priceBodyTemplatee(formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4)

                                                                }
                                                            </td>

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.projection)}</td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.yearly)}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? priceBodyTemplateeYearly(item.projection - formik.values.q1) : index == 1 ? priceBodyTemplateeYearly(item.projection - formik.values.q2) : index == 2 ? priceBodyTemplateeYearly(item.projection - formik.values.q3) : index == 3 ? priceBodyTemplateeYearly(item.projection - formik.values.q4) : priceBodyTemplateeYearly(item.projection - (formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4))

                                                                }
                                                            </td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.vpComments}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`vpCommentsq1`,  formik.values.vpCommentsq1) :
                                                                        index == 1 ? renderTextAreaFull(`vpCommentsq2`,  formik.values.vpCommentsq2) :
                                                                            index == 2 ? renderTextAreaFull(`vpCommentsq3`,  formik.values.vpCommentsq3) :
                                                                                index == 3 ? renderTextAreaFull(`vpCommentsq4`,  formik.values.vpCommentsq4) :
                                                                                (<div className='p-4'></div>)
                                                                }
                                                            </td>

                                                            {/* <td className='px-2' style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`coreValuesq1`,  formik.values.coreValuesq1 , "") :
                                                                        index == 1 ? renderTextAreaFull(`coreValuesq2`,  formik.values.coreValuesq2 , "") :
                                                                            index == 2 ? renderTextAreaFull(`coreValuesq3`,  formik.values.coreValuesq3 , "") :
                                                                                index == 3 ? renderTextAreaFull(`coreValuesq4`,  formik.values.coreValuesq4, "") :
                                                                                    (<div className='p-4'></div>)
                                                                }
                                                            </td> */}

                                                            
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="ANNUAL DELIVERABLES" className='mt-2 '>


                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "300px" }}>
                                                    Annual Deliverables
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    Year Goal
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: 'auto', }}>
                                                     Core Values
                                                </th>
                                                <th style={{ ...headerStyle, width: '80px', }}>
                                                    Action
                                                </th>



                                            </tr>
                                        </thead>
                                        <tbody>
                                            {annualDeliverables.map((item, index) => (
                                                <tr>

                                                    <td style={{ ...cellStyle, }}>{renderInputArea(`annual_deliveables.${index}.title`, formik.values.annual_deliveables[index].title,)}</td>
                                                    <td style={{ ...cellStyle, }}>{renderTextAreaFull(`annual_deliveables.${index}.description`, formik.values.annual_deliveables[index].description)}</td>
                                                    <td style={{ ...cellStyle, }}>{renderTextAreaFull(`annual_deliveables.${index}.lida_homes_core_value`, formik.values.annual_deliveables[index].lida_homes_core_value)}</td>
                                                    <td style={cellStylea}>
                                                        {formik.values.annual_deliveables.length != 1 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForAnnualDeliverables(index)} />) : null}

                                                        {formik.values.annual_deliveables.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForAnnualDeliverables()} />

                                                        ) : null}

                                                    </td>
                                                </tr>

                                            ))}

                                        </tbody>
                                    </table>

                                </div>

                                <div className="table-container form-bg" style={{ overflowX: "auto", }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>

                                                <th style={{ ...cellStyle, width: "200px" }}  >
                                                    Check in:  How are you doing?
                                                </th>
                                                <th style={{ ...cellStyle, width: "300px" }}>{renderTextAreaFull(`check_in_how_are_you_doing`, formik.values.check_in_how_are_you_doing)}</th>
                                            </tr>
                                            <tr>

                                                <th style={{ ...cellStyle, width: "200px" }} >
                                                    What can I do to support you?
                                                </th>
                                                <th style={{ ...cellStyle, width: "300px" }}>{renderTextAreaFull(`what_can_i_do_to_support_you`, formik.values.what_can_i_do_to_support_you)}</th>
                                            </tr>

                                        </thead>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="PAYROLL" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", width: "auto" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "300px" }} >
                                                    Payroll Date:
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "200px" }} >
                                                    From:
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >

                                                    {billableTime.length > 0 ? billableTime[0].payPeriodStartDate : ''}
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    To:
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >

                                                    {billableTime.length > 0 ? billableTime[0].payPeriodEndDate : ''}
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} colSpan={9}>
                                                   Labour Billable VS Unbillable Profit/Loss
                                                </th>

                                            </tr>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "" }}>
                                                    Division
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Name
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Billable Rate
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Billable Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Unbillable Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "180px" }} >
                                                    Vacation/Stat Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    EOS Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Sales Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Sick Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Total Hours
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    % Unbillable Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Loss vs Billable
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Loss vs LB
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "650px" }} >
                                                    VP Construction Ops Comments
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {billableTime.length != 0 ? billableTime.map((billableTime, index) => {
                                                return (
                                                    <tr>
                                                        <td style={cellStylea}>{billableTime.division}</td>
                                                        <td style={cellStylea}>{billableTime.name}</td>
                                                        <td style={cellStyle}>${billableTime.billableRate}</td>
                                                        <td style={cellStyle}> {billableTime.billableTime} </td>
                                                        <td style={cellStyle}> {billableTime.unBillableTime} </td>
                                                        <td style={cellStyle}> {billableTime.vacatiomStatTime} </td>
                                                        <td style={cellStyle}> {billableTime.eosTime}</td>
                                                        <td style={cellStyle}> {billableTime.salesTime} </td>
                                                        <td style={cellStyle}>{billableTime.sickTime} </td>
                                                        <td style={cellStyle}> {billableTime.totalHours} </td>
                                                        <td style={cellStyle}>{billableTime.vacatiomStatTime}</td>
                                                        <td style={cellStyle}>$0.00</td>
                                                        <td style={cellStyle}>$0.00</td>
                                                        <td style={cellStyleW}>
                                                            <textarea
                                                                placeholder=""
                                                                style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none' }}
                                                            >
                                                            </textarea>
                                                        </td>
                                                    </tr>
                                                )



                                            }) : (

                                                <tr>
                                                    <td style={cellStyle}></td>
                                                    <td style={cellStyle}>{userName}</td>
                                                    <td style={cellStyle}>$0</td>
                                                    <td style={cellStyle}>0 </td>
                                                    <td style={cellStyle}> 0 </td>
                                                    <td style={cellStyle}> 0 </td>
                                                    <td style={cellStyle}> 0</td>
                                                    <td style={cellStyle}> 0 </td>
                                                    <td style={cellStyle}>0 </td>
                                                    <td style={cellStyle}> 0</td>
                                                    <td style={cellStyle}>0</td>
                                                    <td style={cellStyle}>$0.00</td>
                                                    <td style={cellStyle}>$0.00</td>
                                                    <td style={cellStyleW}>
                                                        <textarea
                                                            placeholder=""
                                                            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none' }}
                                                        >
                                                        </textarea>
                                                    </td>
                                                </tr>

                                            )}






                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="PERFORMANCE BONUS MEASURABLES REVIEW" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th colSpan={3} >

                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto", }} >
                                                    Week Ending
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    {dateInput2}
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    {dateInput2}
                                                </th>
                                                {/* <th style={{ ...headerStyle, }} >
                                                    {dateInput3}
                                                </th>
                                                <th style={{ ...headerStyle, }} >
                                                    {dateInput4}
                                                </th>
                                                <th colSpan={3}>

                                                </th> */}

                                            </tr>
                                            <tr>
                                                <th colSpan={3} style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Performance Bonus Measurables Review
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >

                                                    <input
                                                        type="text"
                                                        value={dataForPer}
                                                        onChange={(e) => {

                                                            setDataForPer(e.target.value)
                                                        }}

                                                        style={{ ...headerStyle, border: 'none', outline: 'none', textAlign: 'center', width: '100%', height: '40px', boxSizing: 'border-box', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                    />
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Performance Points
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    VP Points
                                                </th>
                                                {/* <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    Performance Points
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    VP POINTS
                                                </th> */}
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    Comments
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    VP Construction Ops Comments
                                                </th>
                                                <th style={{ ...cellStyle, width: "80px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {perBonusMeasurablesReview.map((item, index) => (

                                                <tr>
                                                    <td style={cellStyleW} colSpan={4}>
                                                        {index < 3 ? formik.values.performance[index].performanceBonusMeasReview : renderTextAreaFull(`performance.${index}.performanceBonusMeasReview`, formik.values.performance[index].performanceBonusMeasReview)}
                                                    </td>

                                                    <td style={{ ...cellStyleW, backgroundColor: "#B7B7B7", }}>
                                                        {renderInputArea(`performance.${index}.clientPlayBook`, formik.values.performance[index].clientPlayBook, 'text', '#B7B7B7', 0)}
                                                    </td>

                                                    <td style={{ ...cellStyleW, backgroundColor: "#F8EED7" }}>
                                                        {renderInputArea(`performance.${index}.vpPoints_1`, formik.values.performance[index].vpPoints_1, 'text', '#F8EED7', 0)}
                                                    </td>

                                                    {/* <td style={{ ...cellStyleW, backgroundColor: "#B7B7B7" }}>
                                                        {renderInputArea(`performance.${index}.clientEmailWeek`, formik.values.performance[index].clientEmailWeek, 'text', '#B7B7B7', 0)} 
                                                    </td>

                                                    <td style={{ ...cellStyleW, backgroundColor: "#F8EED7" }}>
                                                        {renderInputArea(`performance.${index}.vpPoints_2`, formik.values.performance[index].vpPoints_2, 'text', '#F8EED7', 0)} 
                                                    </td> */}

                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`performance.${index}.pmComments`, formik.values.performance[index].pmComments)}
                                                    </td>

                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`performance.${index}.vpCOComments`, formik.values.performance[index].vpCOComments)}
                                                    </td>

                                                    <td style={cellStylea}>

                                                        {index > 2 ? (<FaTrash onClick={() => handleDeleteInputForMonthlyClientRating(index)} className='delete-buttonXX' />) : null}

                                                        {perBonusMeasurablesReview.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForMonthlyClientRating()} className='add-buttonXX' />) : null}

                                                    </td>

                                                </tr>
                                            ))}

                                            <tr>
                                                <td style={{ ...cellStyle, fontWeight: 'bold' }} colSpan={4}>Total points for the week - {'>'}  45 points is meeting job requirements/full bonus</td>

                                                <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('clientPlayBook')}</td>
                                                <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('vpPoints_1')}</td>
                                                {/* <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('clientEmailWeek')}</td>
                                                <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('vpPoints_2')}</td> */}
                                                <td style={{ ...cellStyle, }}></td>
                                                <td style={{ ...cellStyle, }}></td>
                                                <td style={{ ...cellStyle, }}></td>
                                            </tr>

                                            <tr>

                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={4}>

                                                    <textarea
                                                        type="text"
                                                        value={totalPointMeetingJob}
                                                        onChange={(e) => {
                                                            setTotalPointMeetingJob(e.target.value)
                                                        }}

                                                        style={{ ...headerStyle, border: 'none', outline: 'none', textAlign: 'start', width: '100%', height: '40px', boxSizing: 'border-box', fontWeight: 'bold', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                    />
                                                </th>

                                                <td style={cellStyle}>
                                                    {cilentPlayBookTotalPerColor('clientPlayBook')}
                                                </td>
                                                <td style={cellStyle}>
                                                    {cilentPlayBookTotalPerColor('vpPoints_1')}
                                                </td>
                                                {/* <td style={cellStyle}>
                                                    {cilentPlayBookTotalPerColor('clientEmailWeek')}
                                                </td>
                                                <td style={cellStyle}>
                                                    {cilentPlayBookTotalPerColor('vpPoints_2')}
                                                </td> */}
                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={4}>

                                                    <textarea
                                                        type="text"
                                                        value={pointsMeetingJob}
                                                        onChange={(e) => {
                                                            setPointsMeetingJob(e.target.value)
                                                        }}

                                                        style={{ ...headerStyle, border: 'none', outline: 'none', textAlign: 'start', width: '100%', height: '40px', boxSizing: 'border-box', fontWeight: 'bold', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                    />
                                                </th>

                                                {/* //* ----------------------------------------- */}

                                            </tr>
                                            <tr>
                                                <td style={{ padding: '10px' }} colSpan={12} >
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }} >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: '#22a33d',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>90% - 100% full bonus</strong>
                                                        </div>

                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: '#FFBF00',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>80% - 89.9% is 80% of bonus</strong>
                                                        </div>

                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: 'red',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>70% - 79.9 is 79% of bonus</strong>
                                                        </div>

                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: 'red',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>Below 70% is no bonus</strong>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStyle, minHeight: "100px" }} colSpan={11}></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: 'auto', textAlign: 'start' }}>
                                                    Discussion Items:
                                                </th>
                                                <th style={{ ...headerStyle, width: "80px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {discussionItem.map((item, index) => (
                                                <tr>
                                                    <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`discussionItem.${index}.discussion_items`, '', formik.values.discussionItem[index].discussion_items)} </td>

                                                    <td style={cellStylea}>
                                                        {formik.values.discussionItem.length != 1 ? (<FaTrash onClick={() => handleDeleteInputFordiscussionItem(index)} className='delete-buttonXX' />) : null}

                                                        {discussionItem.length - 1 == index ? (<FaPlus onClick={() => handleAddInputFordiscussionItem()} className='add-buttonXX' />) : null}


                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>


                            <AccordionTab header="GOALS FOR THE WEEK" className='mt-2 '>


                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, }}>
                                                    Goals for the week
                                                </th>

                                                <th style={{ ...headerStyle, }}>

                                                </th>
                                                <th style={{ ...headerStyle, }}>

                                                </th><th style={{ ...headerStyle, }}>

                                                </th>
                                                <th style={{ ...headerStyle, width: "80px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {goalsForTheWeek.map((item, index) => (
                                                <>
                                                    <tr>

                                                        <td style={{ ...cellStyleW, width: "300px" }} rowSpan={2}>{renderTextAreaFull(`goals_for_the_week.${index}.title`, formik.values.goals_for_the_week[index].title,)}</td>

                                                        <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`goals_for_the_week.${index}.status_1`, formik.values.goals_for_the_week[index].status_1)} </td>
                                                        <td style={{ ...headerStyle, width: '185px', }}>Last Week </td>

                                                        <td style={{ ...cellStyle, minWidth: "auto" }}>{renderTextAreaFull(`goals_for_the_week.${index}.reason_1`, formik.values.goals_for_the_week[index].reason_1)}</td>



                                                        <td style={cellStylea} rowSpan={2} >
                                                            {formik.values.goals_for_the_week.length != 1 ? (<FaTrash onClick={() => handleDeleteInputForGoalsForTheWeek(index)} className='delete-buttonXX' />) : null}

                                                            {formik.values.goals_for_the_week.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForGoalsForTheWeek()} className='add-buttonXX' />) : null}

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`goals_for_the_week.${index}.status_2`, formik.values.goals_for_the_week[index].status_2)} </td>
                                                        <td style={{ ...headerStyle, width: '185px', }}>This Week </td>

                                                        <td style={{ ...cellStyle, width: "auto" }}>{renderTextAreaFull(`goals_for_the_week.${index}.reason_2`, formik.values.goals_for_the_week[index].reason_2)}</td>
                                                    </tr>
                                                </>

                                            ))}

                                        </tbody>
                                    </table>



                                    <table style={{ borderCollapse: "collapse", marginTop: "20px", marginBottom: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, }} colSpan={2}>                                                    
                                                    To Discuss (ie. Customer issues, crew issues, customer closing, etc.)
                                                </th>
                                                <th style={{ ...headerStyle, width: "80px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {toDiscuss.map((item, key) => (
                                                <tr key={key}>

                                                    <td style={{ ...cellStyleW, width: '300px' }}>{renderTextAreaFull(`toDiscuss.${key}.title`, item.title)} </td>
                                                    <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`toDiscuss.${key}.description`, item.description)} </td>

                                                    <td style={cellStylea}>

                                                        {key != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputFortoDiscuss(key)} />) : null}

                                                        {toDiscuss.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputFortoDiscuss()} />) : null}

                                                    </td>

                                                </tr>
                                            ))}



                                        </tbody>
                                    </table>

                                </div>

                            </AccordionTab>

                        </Accordion>

                    )}

                </div>
            </form>



        </>
    )
}

export default VpSalesAndMarketing

